import styled from "styled-components";

export const StyledSectionWrapper = styled.div`
  background-image: url("./images/second-slider-line.png");
  background-repeat: no-repeat;
  background-position: 17% 50%;
  padding-bottom: 60px;
  padding-top: 44px;
  & > p {
    text-align: center;
    font-size: 13.9652px;
    line-height: 17px;
    color: #96a8be;
  }
  & > h2 {
    font-weight: bold;
    font-size: 32px;
    line-height: 40px;
    text-align: center;
    color: #233247;
    padding: 0 10px;
    margin: 18px 0 31px;
  }

  @media (min-width: ${({ theme }) => theme.queries.sm}) {
    background-size: 100% auto;
    background-position: 0 90%;
  }
  @media (min-width: ${({ theme }) => theme.queries.lg}) {
    padding-top: 76px;
  }
`;
